module.exports = __webpack_public_path__ + "img/slashMan.8586ba61.png";